package com.jet.classroomhero

actual class Logger actual constructor() {
    actual fun logMessage(msg: String) {
        if (Utils.isDebug){
            console.log(msg)
        }
    }
}